import { render, staticRenderFns } from "./InsectCountByTypeBarChart.vue?vue&type=template&id=4d2f3495&"
import script from "./InsectCountByTypeBarChart.vue?vue&type=script&lang=js&"
export * from "./InsectCountByTypeBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d2f3495')) {
      api.createRecord('4d2f3495', component.options)
    } else {
      api.reload('4d2f3495', component.options)
    }
    module.hot.accept("./InsectCountByTypeBarChart.vue?vue&type=template&id=4d2f3495&", function () {
      api.rerender('4d2f3495', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/InsectCountByTypeBarChart.vue"
export default component.exports